import './eqc-fullscreen.scss'
import 'object-fit-polyfill'
import $ from 'jquery'

const close = '<img class="brandhub-image-close" src="../../../static/static-assets/eqc/page/close.svg"/>'

$(document).ready(() => {
  $('.brandhub-image-expandable').each((index, item) => {
    const self = {
      elem: null,
      overlay: null,
      init: function (elem) {
        self.elem = elem
        this.addOpenIcon()
        this.bindExpand()
      },
      addOpenIcon: function () {
        const html = `
          <div class="brandhub-image-expandable-icon brandhub-image-expandable-open">
            <img src="../../../static/static-assets/eqc/page/expand.svg"/>
          </div>
         `
        this.addIcon(html)
      },
      addIcon: function (html) {
        $($.parseHTML(html)).appendTo(self.elem)
      },
      bindExpand: function () {
        $(self.elem).find('img').click(() => {
          this.expand()
        })
      },
      bindClose: function () {
        this.overlay.click(event => {
          if ($('html').hasClass('isTouch') && !$(event.target).hasClass('brandhub-image-close')) {
            return
          }
          this.reduce()
        })
      },
      fitOverlayToImage () {
        this.overlay.width($(self.elem).find('img').width())
        this.overlay.height($(self.elem).find('img').height())
        this.overlay.css('top', $(self.elem).offset().top)
        this.overlay.css('left', $(self.elem).offset().left)
      },
      fitOverlayToWindow () {
        this.overlay.css({
          width: $(window).width(),
          height: $(window).height(),
          left: 0,
          top: 0
        })
        setTimeout(() => {
          this.overlay.css({
            width: '100%',
            height: '100%'
          })
        }, 300)
      },
      disableScrolling () {
        $('html, body').css({
          overflow: 'hidden',
          height: '100%'
        })
      },
      enableScrolling () {
        $('html, body').css({
          overflow: 'inherit',
          height: 'inherit'
        })
      },
      setupCloseButton () {
        const $closeButton = $($.parseHTML(close))
        $closeButton.appendTo(this.overlay)

        this.overlay.find('img').on('mousedown touchstart', () => {
          $closeButton.fadeOut(200)
        })
          .on('mouseup touchend touchcancel', () => {
            $closeButton.fadeIn(200)
          })
      },
      expand: function () {
        this.disableScrolling()
        this.overlay = $('<div class="brandhub-image-overlay"></div>')
        this.fitOverlayToImage()

        $('body').append(this.overlay)
        const $clonedImage = $(self.elem).find('img').clone()
        $clonedImage.appendTo(this.overlay)
        $clonedImage.attr('src', $clonedImage.data('src'))

        this.fitOverlayToWindow()
        setTimeout(() => {
          const left = (this.overlay.find('img').width() / 2 - ($(window).width() / 2))
          this.overlay.animate({scrollLeft: left}, 200)
        }, 200)

        this.setupCloseButton()
        this.bindClose()
      },
      reduce: function () {
        this.fitOverlayToImage()
        $('.brandhub-image-close').remove()
        setTimeout(() => {
          $(this.overlay).hide()
          $(this.overlay).remove()
          this.enableScrolling()
        }, 300)
      }
    }
    self.init(item)
  })
})



// WEBPACK FOOTER //
// ./src/components/eqc/eqc-fullscreen.js